/** Ezreal AbilitySpec seed kit (wiki-aligned numeric batch 3). */
export const EZREAL_ABILITY_DEFS = [
  {
    id: 'ezreal_q',
    champKey: 'ezreal',
    slot: 'Q',
    name: 'Mystic Shot',
    targeting: 'skillshot_line',
    range: 1200,
    castTime: 0.25,
    travelSpeed: 2000,
    width: 120,
    radius: 60,
    cooldown: 5.5,
    manaCost: 28,
    vfxId: 'ezreal_q',
    status: 'wired'
  },
  {
    id: 'ezreal_w',
    champKey: 'ezreal',
    slot: 'W',
    name: 'Essence Flux',
    targeting: 'skillshot_line',
    range: 1200,
    castTime: 0.25,
    travelSpeed: 1700,
    width: 160,
    radius: 80,
    cooldown: 8,
    manaCost: 50,
    vfxId: 'ezreal_w',
    status: 'wired'
  },
  {
    id: 'ezreal_e',
    champKey: 'ezreal',
    slot: 'E',
    name: 'Arcane Shift',
    targeting: 'blink',
    range: 475,
    castTime: 0.25,
    travelSpeed: null,
    width: null,
    radius: null,
    cooldown: 26,
    manaCost: 70,
    vfxId: 'ezreal_e',
    status: 'wired'
  },
  {
    id: 'ezreal_r',
    champKey: 'ezreal',
    slot: 'R',
    name: 'Trueshot Barrage',
    targeting: 'skillshot_line',
    range: 5000,
    castTime: 1,
    travelSpeed: 2000,
    width: 320,
    radius: 160,
    cooldown: 120,
    manaCost: 100,
    vfxId: 'ezreal_r',
    status: 'wired'
  }
];
